import { Helmet } from 'react-helmet';
import { Outlet, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import {
  Section,
  SectionItem,
  SectionLink,
  SectionName,
} from '../components/Chrome';
import Loader from '../components/Loader';
import Icon from '../components/Icon';
import { SPACE, VIEWER } from '../utilities/queries';
import { useSpaceContext } from '../contexts/space';

const SpaceSettingsPage = () => {
  const params = useParams();
  const { spaceVars } = useSpaceContext();
  const { data, loading } = useQuery(SPACE, {
    variables: { slug: params.s, ...spaceVars },
  });
  const { data: viewerData } = useQuery(VIEWER, {
    skip: !localStorage.getItem('token'),
  });

  return (
    <>
      <Helmet>
        <title>Space settings</title>
      </Helmet>
      <Section>
        {loading && !data ? (
          <Loader />
        ) : (
          <>
            {viewerData && data.space && data.space.role === 'ADMIN' ? (
              <>
                <SectionName>Space settings</SectionName>
                <SectionLink to="main">
                  Main
                  <Icon name="arrow-right" />
                </SectionLink>
                <SectionLink to="plan">
                  Plan
                  <Icon name="arrow-right" />
                </SectionLink>
                <SectionLink to="tags">
                  Tags
                  <Icon name="arrow-right" />
                </SectionLink>
                {data.space.ownerId === viewerData.viewer.id && (
                  <SectionLink to="data">
                    Data
                    <Icon name="arrow-right" />
                  </SectionLink>
                )}
                <SectionLink to="archives">
                  Archives
                  <Icon name="arrow-right" />
                </SectionLink>
                <SectionLink to="members">
                  Members
                  <Icon name="arrow-right" />
                </SectionLink>
                <SectionLink to="preferences">
                  Preferences
                  <Icon name="arrow-right" />
                </SectionLink>
              </>
            ) : (
              <>
                <SectionItem>
                  {data && data.space && data.space.role !== 'ADMIN'
                    ? 'You do not have permission to view this page.'
                    : 'There is no space with that url.'}
                </SectionItem>
              </>
            )}
          </>
        )}
      </Section>
      {viewerData && data && data.space && data.space.role === 'ADMIN' && (
        <>
          {location.pathname.includes(`/s/${params.s}/settings/data`) ? (
            <>{data.space.ownerId === viewerData.viewer.id && <Outlet />}</>
          ) : (
            <Outlet />
          )}
        </>
      )}
    </>
  );
};

export default SpaceSettingsPage;
